/* eslint-disable react-hooks/static-components */
import React, {Fragment, useCallback, useEffect, useRef} from "react";
import {get} from "lodash";
import {Badge, Card, CardBody, CardHeader} from "reactstrap";
import {FaCog, FaStar} from "react-icons/fa";
import {FaRegStar} from "react-icons/fa6";
import {useDispatch, useSelector} from "react-redux";
import Map from "../../../components/GoogleMap/GoogleMap";
import CloneProfile from "../../../components/Modal/CloneProfile";
import EditController from "../../../components/Modal/EditController";
import ProtectedContent, {usePermissionCheck} from "../../../components/protectedContent";
import {isProdMode} from "../../../constants/mode";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {
  requestControllerProperties,
  requestFavourite,
  sendFavourite,
} from "../../../redux/Actions/controllers.actions";
import {
  getFavourite,
  getSelectedController,
} from "../../../redux/Selectors/controllers.selectors";
import {OVERVIEW_DETAILS_LIST} from "./overview.constants";
import "./overview.scss";

function Overview({ioTypes}) {
  const {isOpen: editModalOpen, toggleOpen: toggleEditModal} = useDisclosure();
  const {isOpen: cloneModalOpen, toggleOpen: toggleCloneModal} = useDisclosure();
  const dispatch = useDispatch();
  const intervalRef = useRef();
  const systemObject = useSelector(getSelectedController);
  const isFav = useSelector(getFavourite);

  const toggleFav = () => {
    if (canChangeSystemFav) {
      dispatch(sendFavourite({add: !isFav}));
    }
  };

  const canViewSystemFav = usePermissionCheck(["view_systeminventoryfav"]);
  const canChangeSystemFav = usePermissionCheck(["change_systeminventoryfav"]);

  const clearTimeInterval = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  useEffect(() => {
    const dataCall = (trackThisPromise = false) => {
      dispatch(requestControllerProperties(trackThisPromise));
    };
    clearTimeInterval();
    dataCall(true);
    if (canViewSystemFav) {
      dispatch(requestFavourite());
    }
    if (isProdMode) {
      intervalRef.current = setInterval(dataCall, 10000);
    }
    return clearTimeInterval;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DisplayRows = () => {
    return OVERVIEW_DETAILS_LIST.map((item, index) => {
      const {key, title} = item;
      const isLastElement = OVERVIEW_DETAILS_LIST.length - 1 === index;
      return (
        <div key={`${title}_${index}`} style={{paddingTop: "10px"}}>
          <div style={{paddingBottom: "0px"}}>
            <h3 style={{marginBottom: "0px"}}>{title}</h3>
          </div>
          <div>
            {key === "properties.state.state_message" ? (
              <Fragment>
                {get(systemObject, key)}
                <Badge color="" className="badge-dot ml-2 badge-lg">
                  <i
                    className={`bg-${get(systemObject, "properties.state.state_color")}`}
                  />
                </Badge>
              </Fragment>
            ) : (
              get(systemObject, key)
            )}
          </div>
          {!isLastElement && <hr style={{marginBottom: "0px", marginTop: "10px"}} />}
        </div>
      );
    });
  };

  const FavIcon = isFav ? FaStar : FaRegStar;

  const toggleModals = () => {
    toggleEditModal();
    toggleCloneModal();
  };

  return (
    <Fragment>
      {editModalOpen && (
        <EditController
          ioTypes={ioTypes}
          open={editModalOpen}
          toggle={toggleEditModal}
          toggleModals={toggleModals}
        />
      )}
      {cloneModalOpen && <CloneProfile open={cloneModalOpen} toggle={toggleCloneModal} />}
      {systemObject && (
        <Card className="shadow">
          <CardHeader className="border-0">
            <div
              className="d-flex justify-content-between"
              style={{
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              <div className="text-center" style={{flexGrow: 1}}>
                <div>
                  <h3 className="mb-0">{systemObject.name}</h3>
                </div>
                <div>
                  <h4>
                    SN #{systemObject.serial}{" "}
                    <ProtectedContent perms={["view_systeminventoryfav"]}>
                      <FavIcon
                        className={isFav ? "fav-star" : ""}
                        style={{cursor: canChangeSystemFav ? "pointer" : ""}}
                        onClick={toggleFav}
                        data-cy="icon_Star"
                      />
                    </ProtectedContent>
                  </h4>
                </div>
              </div>
              <div>
                <FaCog
                  style={{cursor: "pointer"}}
                  onClick={toggleEditModal}
                  data-cy="Edit_Controller"
                />
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <div style={{height: "180px"}}>
              <Map address={systemObject.location} />
            </div>
            <div style={{padding: "10px 0px 0px 10px"}}>
              <DisplayRows />
            </div>
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
}

export default Overview;
